import { Modal, View, Platform, StyleSheet, Pressable } from 'react-native'
import { palette } from '../../../theme/palette'
import { ReactNode } from 'react'

const isWeb = Platform.OS === 'web'

/**
 * On native, uses React Native's `Modal` for proper OS-level overlay behavior.
 * On web, uses an absolute-positioned overlay to avoid portal/z-index stacking
 * issues that react-native-web's Modal implementation can cause when multiple
 * modals mount and unmount.
 */
export const GameModal = ({
  visible,
  onClose,
  verticalOffset,
  children
}: {
  visible: boolean
  verticalOffset?: number
  onClose: () => void
  children: ReactNode
}) => {
  if (isWeb) {
    if (!visible) return null

    return (
      <View style={webStyles.overlay}>
        <Pressable style={webStyles.backdrop} onPress={onClose} />
        <View
          style={[webStyles.contentWrapper, { transform: [{ translateY: verticalOffset ?? 0 }] }]}
          pointerEvents="box-none"
        >
          <Pressable style={modalStyles.container} onPress={(e) => e.stopPropagation()}>
            {children}
          </Pressable>
        </View>
      </View>
    )
  }

  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onClose}>
      <View style={modalStyles.backdrop}>
        <View style={[modalStyles.container, { transform: [{ translateY: verticalOffset ?? 0 }] }]}>{children}</View>
      </View>
    </Modal>
  )
}

const modalStyles = StyleSheet.create({
  backdrop: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: palette.blackWithOpacity.twenty
  },
  container: {
    backgroundColor: palette.cream,
    borderRadius: 12,
    width: '80%',
    display: 'flex',
    justifyContent: 'center',
    maxWidth: Platform.select({ web: 500 })
  }
})

const webStyles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 9999
  },
  backdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: palette.blackWithOpacity.twenty
  },
  contentWrapper: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    alignItems: 'center'
  }
})
